<template>
  <div>
    <van-nav-bar title="积分转换" left-text="" left-arrow @click-left="onClickLeft" />
      <div v-if="!isLogined" style="padding-top:300px;" class="nomain">
        <p>您还没有登录哦，请先登录</p>
        <van-button round @click="ShowLogin" type="info">点击登录</van-button>
      </div>
    <div v-else class="main">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="此功能仅限误工积分以1:1的比例兑换为物资积分，此功能不可逆，请谨慎操作！"
      /> 
      <van-field v-model="sdworker.Integral" label="误工积分" readonly />
      <van-field v-model="sdworker.MaterialIntegral" label="物资积分" readonly />
      <van-field v-model="converIntegral" label="转换积分" placeholder="请输入转换积分" />
      <div style="margin: 16px;">
        <van-button round block type="info" @click="OnConver">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Field, NavBar, NoticeBar } from "vant";
export default {
  name: "",
  data() {
    return {
      sdworkerId: 0,
      converIntegral: 0,
      sdworker: {
        MaterialIntegral: 0,
        Integral: 0,
        LockIntegral: 0,
        Tel: "",
        ID: 0,
      },
    };
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    ShowLogin() {
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    GetData() {
      var that = this;
      if (that.isLogined) {
        that.$http.get("SDWorker/GetSDWorker", {
          params: {
            id: that.sdworkerId,
          }
        }).then(res=>{
          that.sdworker = res.data.Data;
        });
      }
    },
    OnConver(){
      var that=this;
      if (that.converIntegral<=0) {
        that.$toast.fail("转换积分必须大于0，请重新输入");
        return;
      }
      that.$http.get("SDWorker/AddConver", {
        params: { 
            sdworkerId: that.sdworkerId,
            integral:  that.converIntegral
        }
      }).then(res => {
        if(res.data=="success"){
          that.$toast("操作成功");
          that.$router.back(-1);
        }else{
          that.$toast(res.data);
        }
      });
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [NoticeBar.name]:NoticeBar,
  },
  created() {
    this.sdworkerId = this.$route.params.sdworkerid;
    this.GetData();
  },
};
</script>

<style>
.nomain{
  text-align: center;
}
.main{
  text-align: left;
}
</style>